import React from 'react';
import { theme } from '../styles/theme';

const PaymentSuccess: React.FC = () => {

  const containerStyles: React.CSSProperties = {
    minHeight: '100vh',
    background: theme.colors.background,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: theme.typography.fontFamily,
    padding: theme.spacing.lg
  };

  const cardStyles: React.CSSProperties = {
    backgroundColor: theme.colors.surface,
    borderRadius: theme.borderRadius.xl,
    padding: theme.spacing['4xl'],
    boxShadow: theme.shadows.xl,
    textAlign: 'center',
    maxWidth: '500px',
    width: '100%',
    border: `2px solid ${theme.colors.success}`
  };

  const iconStyles: React.CSSProperties = {
    fontSize: '64px',
    marginBottom: theme.spacing.lg
  };

  const titleStyles: React.CSSProperties = {
    fontSize: theme.typography.sizes['3xl'],
    fontWeight: theme.typography.weights.bold,
    color: theme.colors.success,
    marginBottom: theme.spacing.md,
    letterSpacing: '-0.02em'
  };

  const messageStyles: React.CSSProperties = {
    fontSize: theme.typography.sizes.lg,
    color: theme.colors.text.secondary,
    marginBottom: theme.spacing['2xl'],
    lineHeight: theme.typography.lineHeights.relaxed
  };

  return (
    <div style={containerStyles}>
      <div style={cardStyles}>
        <div style={iconStyles}>✓</div>

        <h1 style={titleStyles}>Thank You for Your Payment</h1>

        <p style={messageStyles}>
          Your payment has been processed successfully. We appreciate your business!
        </p>
      </div>
    </div>
  );
};

export default PaymentSuccess;